/* eslint-disable react/prop-types */
// @ts-nocheck
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Typography,
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useCallback } from 'react';
import { alpha } from '@mui/material/styles';
import { ReactComponent as DropdownArrow } from '../../assets/images/DropdownArrow.svg';

/**
 * @function TransparentDropdown
 * @description UI dropdown
 * @param {string} label - to add label
 * @param {string} name - to add name
 * @param {string} value - to add value
 * @param {any} onChange - to add onChange
 * @param {string} helperText - to add helperText
 * @param {any} children - to add children
 * @param {boolean} required - to add required
 * @param {any} props - to add props
 * @returns a jsx component
 * @example TransparentDropdown()
 */

const BACKGROUND_COLOR = 'transparent !important';

const TransparentDropdown = React.memo(
  ({
    id,
    label,
    name,
    value,
    onChange,
    helperText,
    children,
    required = false,
    descriptionClass = '',
    ...props
  }) => {
    const renderDropdownArrow = useCallback(
      (_props) => <DropdownArrow {..._props} />,
      []
    );

    const selectSx = useCallback(
      (theme) => ({
        backgroundColor: BACKGROUND_COLOR,
        '& .MuiTypography-root': {
          color: `${theme.palette.primary.main} !important`,
        },
        '& .MuiSelect-icon': {
          right: '10px',
        },
        '& .MuiSelect-select': {
          backgroundColor: BACKGROUND_COLOR,
          paddingLeft: '10px',
          paddingTop: '10px',
          '&:focus-visible': {
            border: `2px solid ${theme.palette.primary.main}`,
            borderRadius: '4px',
          },
        },
        '& .MuiFilledInput-input': {
          backgroundColor: BACKGROUND_COLOR,
        },
        '& .MuiInputBase-input': {
          backgroundColor: BACKGROUND_COLOR,
        },
      }),
      []
    );
    return (
      <FormControl
        error={Boolean(helperText)}
        variant="filled"
        aria-describedby={descriptionClass}
        sx={{
          minWidth: 120,
          outline: 'none',
          borderRadius: '4px',
        }} // Ensure a minimum width and no outline
      >
        <InputLabel id={`${id}-label`} required={required}>
          {label}
        </InputLabel>
        <Select
          id={id}
          aria-labelledby={`${id}-label ${descriptionClass}`}
          name={name}
          value={value}
          onChange={onChange}
          IconComponent={renderDropdownArrow}
          sx={selectSx}
          variant="filled"
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            style: {
              marginTop: '0.1rem',
            },
            PaperProps: {
              style: {
                maxHeight: 300,
                overflowY: 'auto',
              },
            },
            sx: (theme) => ({
              '& .MuiList-root': {
                padding: '6px',
                borderRadius: '4px',
                fontSize: 14,
              },
              '& .MuiPopover-paper, & .MuiMenu-paper': {
                boxShadow: `0px 6px 12px ${alpha(
                  theme.palette.other.lightBrandBlueLogin,
                  0.31
                )}`,
                marginTop: '5px',
              },
              '& .MuiMenuItem-root': {
                color: alpha(theme.palette.primary.main, 0.5),
                backgroundColor: theme.palette.other.white,
                marginTop: '4px',
                height: '40px',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: theme.palette.other.blue1,
                },
                '&:focus': {
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.other.black,
                },
              },
            }),
          }}
          {...props}
        >
          {children}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
  }
);

const DropdownItem = React.memo((props) => (
  <MenuItem {...props}>
    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      <Typography variant="body2">{props.children}</Typography>
    </div>
  </MenuItem>
));

export { TransparentDropdown, DropdownItem };
